var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoY = function SvgLogoY(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "24px",
    viewBox: "0 0 16 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "19D0FDF7-BC06-4F2A-9452-D2FBC421F867@0.5x")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-180.000000, -65.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LogoEy",
    transform: "translate(180.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4673015,0.117377996 C13.9033109,-0.0741164494 13.2875314,-0.0299768771 12.7555894,0.24007491 C12.2236474,0.510126697 11.8191747,0.983940082 11.6312569,1.557157 L5.23256195,21.0009376 C5.04400229,21.5737137 5.08718152,22.1991438 5.35259553,22.7395654 C5.61800954,23.279987 6.08390382,23.6911047 6.64773111,23.8824281 L6.64773111,23.8824281 C7.21147359,24.0740094 7.82703959,24.0301382 8.35893783,23.7604711 C8.89083606,23.490804 9.29546981,23.017444 9.48377575,22.4445817 L15.8843728,2.99886859 C16.2757365,1.80561715 15.6414549,0.515861061 14.4673015,0.117377996 Z",
    id: "Path",
    fill: "#FD5F55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29774304,6.85631675 L4.36710232,1.557157 C3.97526364,0.364405019 2.70594901,-0.279773371 1.53200873,0.118344291 C0.358068457,0.516461953 -0.275950158,1.80611661 0.11588852,2.99886859 L2.04462713,8.29802834 C2.2329552,8.87138709 2.63779245,9.34522136 3.17004026,9.61524729 C3.70228807,9.88527323 4.31832621,9.92936092 4.88257388,9.73780734 L4.88257388,9.73780734 C6.05596662,9.33851582 6.68927427,8.04900915 6.29774304,6.85631675 Z",
    id: "Path",
    fill: "#FDC355"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoY, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logoY.cdee927f.svg";
export { ForwardRef as ReactComponent };